import SMenuController from '../parsers/s-menu';

export default function ({ logoBlack, _uid, _editable, navigation }) {
  return {
    _uid,
    _editable,
    logoBlack: logoBlack?.filename,
    navigation: navigation ? SMenuController(navigation[0]) : undefined
  };
}
